import React, { useState } from 'react';
import { Accordion } from '../Accordion/Accordion';
import styles from './WhyProcess.module.scss';
const leftColumnItems = [
    { id: 1, title: 'Ощущение чистоты и доверие', content: 'Тусклая прихожая, засвеченное окно или серая ванная на обычных фото со смартфона подсознательно ассоциируются у гостя с неухоженностью. Правильный баланс белого и чистая картинка мгновенно повышают доверие к объекту.' },
    { id: 2, title: 'Объем и воздух', content: 'Неудачный ракурс и плохой свет визуально «съедают» пространство. Небольшая кухня или спальня на таких кадрах могут казаться тесными чуланами. Профессиональная цветокоррекция и работа с тенями возвращают комнате ее реальный размер и воздух.' },
    { id: 3, title: 'Создание уюта', content: 'Пустая гостиная часто выглядит холодно и неуютно. Деликатная обработка, акцент на текстурах дерева или текстиля (и, при необходимости, виртуальное добавление декора) превращают безликие стены в место, где хочется провести выходные.' },
];

const rightColumnItems = [
    { id: 1, title: 'Ограничения умной оптики', content: 'Даже самая дорогая камера смартфона искажает реальность и не способна охватить комнату так, как это делает человеческий глаз. Автоматические алгоритмы телефона часто превращают красивый вид из окна в слепящее белое пятно, а углы комнаты уводят в неестественную темноту. Обработка компенсирует эти технические сбои и показывает объект таким, каким он выглядит вживую.' },
    { id: 2, title: 'Управление вниманием и визуальный шум', content: 'На непрофессиональных кадрах в глаза часто бросаются случайные детали: неудачные блики на плитке, кривые отражения в зеркале прихожей, моток проводов или резкие тени от люстры. Этот визуальный мусор отвлекает арендатора от главных плюсов квартиры. Ретушь аккуратно сглаживает эти дефекты, фокусируя взгляд гостя на достоинствах интерьера.' },
    { id: 3, title: 'Независимость от погоды за окном', content: 'Роскошная квартира может выглядеть депрессивно только потому, что фотографии делались в пасмурный или дождливый день. Тусклый свет из окна подсознательно отталкивает. Цветокоррекция и замена серого неба на приятный светлый день кардинально меняют восприятие пространства, добавляя ему жизни и энергии.' },
];

export const WhyProcess: React.FC = () => {
    // Состояния для хранения ID открытых аккордеонов (null - если все закрыты)
    const [openLeftId, setOpenLeftId] = useState<number | null>(null);
    const [openRightId, setOpenRightId] = useState<number | null>(null);

    const handleToggleLeft = (id: number) => {
        setOpenRightId(null);
        setOpenLeftId(openLeftId === id ? null : id);
    };

    const handleToggleRight = (id: number) => {
        setOpenLeftId(null);
        setOpenRightId(openRightId === id ? null : id);
    };

    return (
        <>
            <h2 className={styles.mainTitle}>
                Зачем мне обрабатывать фотографии,<br />
                <span className={styles.gradientText}>если на них и так все видно?</span>
            </h2>

            <div className={styles.grid}>

                {/* Левая колонка */}
                <div className={styles.card}>
                    <p className={styles.subtitle}>Гости платят не за квадратные метры, а за эмоции и комфорт.</p>
                    <p className={styles.description}>
                        У вас есть всего{' '}
                        <span className={styles.highlightBlue}>2-3 секунды,</span> чтобы зацепить потенциального гостя или покупателя.
                    </p>

                    <div className={styles.accordionsList}>
                        {leftColumnItems.map(item => (
                            <Accordion
                                key={item.id}
                                theme="blue"
                                title={item.title}
                                content={item.content}
                                // Передаем true, если id этого элемента совпадает с тем, что хранится в стейте
                                isOpen={openLeftId === item.id}
                                // Передаем функцию, которая сработает при клике
                                onToggle={() => handleToggleLeft(item.id)}
                            />
                        ))}
                    </div>
                </div>

                {/* Правая колонка */}
                <div className={styles.card}>
                    <p className={styles.subtitle}>Хороший интерьер вживую — это только половина успешной сдачи.</p>
                    <p className={styles.description}>
                        <span className={styles.highlightGreen}>Смартфон искажает реальность,</span>{' '}
                        лишая кадр того самого настроения, за которое готовы платить.
                    </p>

                    <div className={styles.accordionsList}>
                        {rightColumnItems.map(item => (
                            <Accordion
                                key={item.id}
                                theme="green"
                                title={item.title}
                                content={item.content}
                                isOpen={openRightId === item.id}
                                onToggle={() => handleToggleRight(item.id)}
                            />
                        ))}
                    </div>
                </div>
            </div>
        </>
    );
};